module.exports = "../fonts/HelveticaNeueLTW01-55Roman.svg";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-55Roman.svg
// module id = 5he4
// module chunks = 1